import { z } from "zod";
import { defineEndpoint } from "./endpoint.js";
import { signupVerificationSchema } from "./signup.js";
/** Deployment mode and the dedicated-instance licence (docs/specs/dedicated.md, PRD §18, B-65). */
export const deploymentSchema = z.object({
    /** `sandbox`: the "Try it yourself" demo instance (docs/specs/sandbox.md). */
    mode: z.enum(["saas", "dedicated", "sandbox"]),
    /** Public self-serve signup (off on a dedicated instance). */
    signupEnabled: z.boolean(),
    /** B-60b: where the signup code goes (the Admin's signup asks for the phone or the e-mail first). */
    signupVerification: signupVerificationSchema,
});
export const getDeployment = defineEndpoint({
    tag: "deployment",
    name: "getDeployment",
    method: "GET",
    path: "/v1/deployment",
    access: { public: true },
    summary: "SaaS or dedicated instance (the Admin hides signup and billing on a dedicated one)",
    status: 200,
    response: deploymentSchema,
});
export const licenceViewSchema = z.object({
    /** `not_required` on SaaS (no licence; the billing page applies). */
    status: z.enum(["not_required", "valid", "invalid"]),
    licenceId: z.uuid().nullable(),
    customer: z.string().nullable(),
    issuedAt: z.iso.datetime().nullable(),
    expiresAt: z.iso.datetime().nullable(),
    /** Contract limits and features from the licence (null = unlimited). */
    entitlements: z.record(z.string(), z.union([z.number(), z.boolean(), z.null()])),
    /** Why the licence is not valid now (unreadable, signature, other business). */
    problem: z.string().nullable(),
});
export const getLicence = defineEndpoint({
    tag: "deployment",
    name: "getLicence",
    method: "GET",
    path: "/v1/licence",
    access: { permission: "billing.view" },
    summary: "The licence of this dedicated instance (`not_required` on SaaS)",
    status: 200,
    response: licenceViewSchema,
});
//# sourceMappingURL=deployment.js.map